const ROLE_LABEL_MAP: Record<string, string> = {
  platform_admin: 'Platform Admin',
  platform_support: 'Platform Support',
  org_owner: 'Org Owner',
  org_admin: 'Org Admin',
  org_staff: 'Org Staff',
  qi_officer: 'QI Officer',
  qi_principal: 'QI Principal',
  exchanger: 'Exchanger',
  advisor: 'Advisor',
  attorney: 'Attorney',
  accountant: 'Accountant',
  title_company: 'Title Company',
  lender: 'Lender',
  viewer: 'Viewer',
  owner: 'Owner',
  admin: 'Admin',
  member: 'Member',
  staff: 'Staff',
  disabled: 'Disabled',
}

export function roleLabel(role: string | null | undefined): string {
  if (!role) return 'No Role'
  return ROLE_LABEL_MAP[role] ?? role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export function roleBadgeVariant(
  role: string | null | undefined,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (!role) return 'outline'
  switch (role) {
    case 'platform_admin':
    case 'org_owner':
      return 'destructive'
    case 'platform_support':
    case 'org_admin':
    case 'qi_officer':
    case 'qi_principal':
      return 'default'
    case 'advisor':
    case 'attorney':
    case 'accountant':
    case 'title_company':
    case 'lender':
    case 'exchanger':
    case 'owner':
    case 'admin':
    case 'member':
    case 'org_staff':
    case 'staff':
      return 'secondary'
    case 'viewer':
    case 'disabled':
      return 'outline'
    default:
      return 'secondary'
  }
}
